<template>
  <VCard class="elevation-12">
    <VToolbar
      dark
      color="primary"
    >
      <VToolbarTitle>User Registration</VToolbarTitle>
    </VToolbar>
    <VCardText>
      <VForm
        ref="form"
        v-model="form"
        @submit="handleRegistration"
      >
        <VTextField
          v-model="firstName"
          :rules="requiredRules"
          label="First Name"
          type="text"
        />
        <VTextField
          v-model="lastName"
          :rules="requiredRules"
          label="Last Name"
          type="text"
        />
        <VTextField
          v-model="email"
          :rules="emailRules"
          label="Your Email"
          type="text"
        />
        <VTextField
          v-model="username"
          :rules="requiredRules"
          label="Username"
          type="text"
        />
        <VTextField
          v-model="password"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          :type="showPassword ? 'text' : 'password'"
          :rules="requiredRules"
          label="Create a password"
          @click:append="showPassword = !showPassword"
        />
        <VTextField
          v-model="secondPassword"
          :append-icon="showSecondPassword ? 'visibility_off' : 'visibility'"
          :type="showSecondPassword ? 'text' : 'password'"
          :rules="confirmPasswordRules"
          label="Confirm your password"
          @click:append="showSecondPassword = !showSecondPassword"
        />
        <VCardActions>
          <div class="caption">
            By clicking this button, you agree to Sndle's <a @click.prevent="privacyDialog = true">Privacy Policy </a> & <a @click.prevent="tosDialog = true">Terms of Use. </a>
          </div>
          <VSpacer />
          <VBtn
            :loading="loading"
            :disabled="!form"
            color="primary"
            type="submit"
            @click.prevent="handleRegistration"
          >
            Register
          </VBtn>
        </VCardActions>
      </VForm>
    </VCardText>
    <NetworkSnackBar />
    <OverflowedTextDialogCard
        v-if="tosDialog"
        card-title="Terms of Service"
        :card-text="tosText"
        :dialog.sync="tosDialog"
    />
    <OverflowedTextDialogCard
        v-if="privacyDialog"
        card-title="Privacy Policy"
        :card-text="privacyText"
        :dialog.sync="privacyDialog"
    />
  </VCard>
</template>

<script>
import { mapGetters } from 'vuex'
import NetworkSnackBar from './NetworkSnackBar'
import OverflowedTextDialogCard from '@/components/OverflowedTextDialogCard'
import tos from '@/assets/tos.json'
import privacy from '@/assets/privacy.json'

export default {
  name: 'UserRegistrationCard',
  components: { NetworkSnackBar, OverflowedTextDialogCard },
  data: function () {
    return {
      form: false,
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      password: '',
      secondPassword: '',
      showPassword: false,
      showSecondPassword: false,
      tosText: tos.text,
      privacyText: privacy.text,
      tosDialog: false,
      privacyDialog: false,
      requiredRules: [v => !!v || 'Required.'],
      emailRules: [
        v => !!v || 'Required.',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      confirmPasswordRules: [
        v => !!v || 'Required.',
        v => v === this.password || 'Password must be the same'
      ]
    }
  },
  computed: {
    ...mapGetters({
      loading: 'account/getUserRegistrationLoading',
      requestPhoneNumber: 'account/getRequestPhoneNumber'
    })
  },
  methods: {
    handleRegistration () {
      const { firstName, lastName, email, username, password } = this
      const { dispatch } = this.$store
      if (this.$refs.form.validate()) {
        dispatch('alert/clear')
          .then(() => dispatch('account/register',
            { firstName, lastName, email, username, password, phoneNumber: this.requestPhoneNumber }
          ))
      }
    }
  }
}
</script>

<style scoped>

</style>
